export const TEAM_INVITE_SAMPLE = {
  firstName: 'Rob',
  lastName: 'Michaels',
  email: 'rob.michaels@highair.com',
  designation: 'Operations Manager',
  companyName: 'HighAir Charters',
  inviterName: 'John Doe',
  registrationUrl: 'https://gotrustjet.com/register/team?d=sample',
};
